export default class RentDto {
  modelName: string;

  hours: number;
}
